import { get, post, put, remove } from '@/helpers/http';

export function fetchDepartments(pagination = {}) {
  return get('/departments', { ...pagination });
}

export function getDepartmentById(id) {
  return get(`/departments/${id}`);
}

export function saveNewDepartment(department) {
  return post('/departments', department);
}

export function updateDepartment(department) {
  return put(`/departments/${department.id}`, department);
}

export function removeDepartment(id) {
  return remove(`/departments/${id}`);
}
